<aside class="rewards-dialog">

  <div class="rewards-dialog__header"
    mat-dialog-title>

    @if (titleDialog?.length > 0) {
      <h2
        class="rewards-dialog__title">
        {{titleDialog}}
      </h2>
    }

  </div>

  <div class="rewards-dialog__content"
    mat-dialog-content>

    @if (anyRewards) {
      <p class="rewards-dialog__message">{{ bodyDialog }}</p>
    } @else {
      <p class="rewards-dialog__message">{{ 'gamification.reward.no-rewards' | translate }}</p>
    }


    @if (coins > 0) {
      <div
        class="rewards-dialog__coins">
        <div class="rewards-dialog__coin-name">{{ coinsName }}</div>
        <div class="rewards-dialog__number-of-coins">+ {{ coins }}</div>
        <mat-icon class="rewards-dialog__coin-icon"
          svgIcon="credits">
        </mat-icon>
      </div>
    }

    @if (!!achievements.length) {
      <ul
        class="rewards-dialog__achievement-list">
        @for (achievement of achievements; track achievement) {
          <li
            class="rewards-dialog__achievement-item">
            <img class="rewards-dialog__achievement-image"
              [src]="achievement.image"
              [attr.alt]="achievement.name"
              [matTooltip]="achievement.name"/>
              <div class="rewards-dialog__achievement-name">{{ 'gamification.new_' + achievement.type | translate }}</div>
            </li>
          }
        </ul>
      }

    </div>

    <div class="rewards-dialog__actions"
      mat-dialog-actions>

      @if (canExit) {
        <button
          class="rewards-dialog__exit-button"
          (click)="dialogRef.close('exit')">
          <span>{{ labelExit }}</span>
        </button>
      }

      @if (authorizeNext) {
        <button
          class="rewards-dialog__next-button"
          (click)="dialogRef.close('next')">
          <span>{{ labelNext }}</span>
          <mat-icon svgIcon="arrow-forward-rounded-500"></mat-icon>
        </button>
      }

    </div>

  </aside>